import React from 'react'

import BkFlowPartnersBenefitsBanner from '../../../partners/BkFlowPartnersBenefitsBanner'
import BkFlowMaterialLoader from '../../../elements/BkFlowMaterialLoader'
import BkFlowError from '../../../elements/BkFlowError'
import BkFlowRoomCardTaxesFees from '../BkFlowRoomCardTaxesFees'
import formatPrice from '../../../../utilities/currency/formatPrice'

import yn from 'yn'

const BkFlowRoomCardRateStagePriceDetails = props => {
	const {
		activeCurrencyData,
		availabilityData,
		configData,
		hotelLabels,
		partnerRateData,
		rateCurrencyCode,
		rateCurrencySymbol,
		ratePlanCancelPolicy,
		ratePlanGuaranteePolicy,
		ratePlanDescription,
		ratePlanDescriptionExtended,
		renderNightlyRates,
		roomRateData,
		roomRateDetailsData,
	} = props

	return (
		<div className="bk-flow-room__price-details-accordion">
			{ yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_DETAILS) &&
				partnerRateData &&
				<BkFlowPartnersBenefitsBanner disableLogo={true} />
			}

			{(ratePlanDescription || ratePlanDescriptionExtended) &&
				<div className="bk-flow-room__price-details-accordion-rate-description">
					<h6>{ hotelLabels && hotelLabels.ratePlanDetails ? hotelLabels.ratePlanDetails : 'Rate Details'}</h6>
					{ratePlanDescriptionExtended ?
						<div className="description extended">{ratePlanDescriptionExtended}</div>
					: ratePlanDescription ?
						<div className="description short">{ratePlanDescription}</div>
					:
						null
					}
				</div>
			}

			{ ratePlanCancelPolicy &&
				<div className="bk-flow-room__price-details-accordion-cancel-policy">
					<h6>{ hotelLabels && hotelLabels.cancellationPolicy ? hotelLabels.cancellationPolicy : 'Cancellation Policy'}</h6>
					<p>{ratePlanCancelPolicy}</p>
				</div>
			}

			{ ratePlanGuaranteePolicy &&
			<div className="bk-flow-room__price-details-accordion-guarantee-policy">
				<h6>{ hotelLabels && hotelLabels.guaranteePolicy ? hotelLabels.guaranteePolicy : 'Guarantee Policy'}</h6>
				<p>{ratePlanGuaranteePolicy}</p>
			</div>
			}

			{ renderNightlyRates ?
				renderNightlyRates
			: roomRateDetailsData.loading ?
				<BkFlowMaterialLoader
					size={25}
				/>
			: roomRateDetailsData.error ?
				<BkFlowError
					configData={ configData}
					availabilityData={ availabilityData }
					requestError={ roomRateDetailsData.error }
				/>
			:
				null
			}

			<BkFlowRoomCardTaxesFees
				hotelLabels={hotelLabels}
				roomRateData={roomRateData}
				activeCurrencyData={activeCurrencyData}
				rateCurrencyCode={rateCurrencyCode}
				rateCurrencySymbol={rateCurrencySymbol}
			/>

			<div className="bk-flow-room__price-details-accordion-row total">
				<p className="label u-font-bold">{ hotelLabels && hotelLabels.total && hotelLabels.total }:</p>
				<p className="value u-font-bold">
					{ rateCurrencySymbol }
					{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate ?
						formatPrice(roomRateData.rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate, 2)
					:
						formatPrice(roomRateData.rates[0].total.amountAfterTax, 2)
					}
					&nbsp;
					{ rateCurrencyCode }
				</p>
			</div>
		</div>
	)
}

export default BkFlowRoomCardRateStagePriceDetails


// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStagePriceDetails.js